import { render, staticRenderFns } from "./SModalCertificacion.vue?vue&type=template&id=840e0598&"
import script from "./SModalCertificacion.vue?vue&type=script&lang=js&"
export * from "./SModalCertificacion.vue?vue&type=script&lang=js&"
import style0 from "./SModalCertificacion.vue?vue&type=style&index=0&id=840e0598&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports